import { Dispatch, ReactElement, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EIconSize } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { Sport as SportType } from 'interfaces/sportsbook-data-levels';
import { EventCollapse } from 'components/EventCollapse';
import { GlobalIcon } from 'components/GlobalIcon';
import { SportDataProvider } from 'providers/SportDataProvider';

const SportHeader = styled.div`
  background-color: var(--v3-black-0);
  border-bottom: 1px solid var(--v3-black-6);
  align-items: center;
  padding: 0 12px;
  display: flex;
  height: 40px;
`;

const Title = styled.span`
  font-size: ${isMobile() ? '12px' : '14px'};
  font-weight: 600;
  color: var(--v3-text-color);
`;

const IconWrapper = styled.span`
  margin-right: 8px;
  color: var(--v3-primary-5);
`;

type Props = {
  type: 'live' | 'prematch';
  gamesCount: number;
  collapsedCount: number;
  favoriteMatches: Record<string, SportType>;
  setCollapsedCount: Dispatch<SetStateAction<number>>;
  competitionElements: (sport: SportType) => ReactElement[];
};

export const FavoriteEvents = ({
  type,
  gamesCount,
  collapsedCount,
  favoriteMatches,
  setCollapsedCount,
  competitionElements
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <EventCollapse
      key={`0-${type}`}
      title={`${t(`sportsbook.${type}`)} (${gamesCount})`}
      defaultActive={true}
      setCollapsedCount={setCollapsedCount}
      collapsedCount={collapsedCount}
      wrapperClassName="favorite__title"
    >
      <>
        {Object.values(favoriteMatches).map(sport => {
          return (
            <div key={`${sport.id}-${type}`}>
              <SportHeader>
                <IconWrapper className="fav__events">
                  <GlobalIcon
                    lib="sports"
                    name={sport.alias || ''}
                    size={EIconSize._24}
                    className="text-color"
                  />
                </IconWrapper>
                <Title>{sport.name}</Title>
              </SportHeader>
              <SportDataProvider sportName={sport.name}>
                {competitionElements(sport)}
              </SportDataProvider>
            </div>
          );
        })}
      </>
    </EventCollapse>
  );
};
